import { useEffect, useState } from 'react';
import translateService from '../services/translateService';

export const useTranslate = () => {
  const [language, setLanguage] = useState(translateService.getLanguage());

  const t = async (text) => {
    if (language === 'es') return text;
    return await translateService.translateText(text, language);
  };

  const changeLanguage = (lang) => {
    translateService.setLanguage(lang);
    setLanguage(lang);
    window.location.reload(); // Recargar para aplicar traducciones
  };

  return { t, language, changeLanguage };
};

// Componente que traduce automáticamente
export const T = ({ children, text }) => {
  const [translated, setTranslated] = useState(text || children);
  const language = translateService.getLanguage();

  useEffect(() => {
    const translate = async () => {
      const originalText = text || children;
      if (language !== 'es' && typeof originalText === 'string') {
        const result = await translateService.translateText(originalText, language);
        setTranslated(result);
      } else {
        setTranslated(originalText);
      }
    };

    translate();
  }, [text, children, language]);

  return <>{translated}</>;
};